import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { HomeComponent } from "./home/home.component";
import { HeaderComponent } from "./header/header.component";
import { EmployersComponent } from "./employers/employers.component";
import { EmployersModule } from "./employers/employers.module";
import { AuthGuardService } from "./auth-guard.service";
import { JobListingComponent } from "./job-listing/job-listing.component";
import { JobDetailsComponent } from "./job-details/job-details.component";
import { ProfileResolver } from "./employer-profile/employer-profile.resolver";
import { ProfileComponent } from "./employer-profile/employer-profile.component";
import { CandidateProfileComponent } from "./candidate-profile/candidate-profile.component";
import { CandidatesListComponent } from "./candidates-list/candidates-list.component";
import { PrivacyPolicyComponent } from "./privacy-policy/privacy-policy.component";
import { FaqComponent } from "./faq/faq.component";
import { AdministratorCvHandlingComponent } from "./administrator-cv-handling/administrator-cv-handling.component";
import { AdministratorJobPostHandlingComponent } from "./administrator-job-post-handling/administrator-job-post-handling.component";
import { AdministratorCompanyHandlingComponent } from "./administrator-company-handling/administrator-company-handling.component";
// import { AdministratorCompanyHandlingResolver } from './administrator-company-handling/administrator-company-handling.resolver';

const routes: Routes = [
  { path: "", redirectTo: "/home", pathMatch: "full" },
  { path: "home", component: HomeComponent },
  { path: "privacy", component: PrivacyPolicyComponent },
  { path: "faq", component: FaqComponent },
  { path: "job-details/:id", component: JobDetailsComponent },
  { path: "candidates/list", component: CandidatesListComponent },
  { path: "job-listing", component: JobListingComponent },
  {
    path: "employer/profile/:id",
    component: ProfileComponent,
    resolve: { data: ProfileResolver },
  },
  {
    path: "candidate/profile/:uuid",
    canActivate: [AuthGuardService],
    component: CandidateProfileComponent,
  },
  {
    path: "candidates",
    canActivate: [AuthGuardService],
    loadChildren: () =>
      import("./candidates/candidates.module").then((m) => m.CandidatesModule),
  },
  {
    path: "employers",
    canActivate: [AuthGuardService],
    loadChildren: () =>
      import("./employers/employers.module").then((m) => m.EmployersModule),
  },
  {
    path: "employers",
    canActivate: [AuthGuardService],
    loadChildren: () =>
      import("./employers/employers.module").then((m) => m.EmployersModule),
  },
  {
    path: "administrator",
    redirectTo: "administrator/login",
    pathMatch: "full",
  },
  {
    path: "administrator/cvHandling/:uuid",
    component: AdministratorCvHandlingComponent,
  },
  // { path: "administrator/companyHandling", component: AdministratorCompanyHandlingComponent , resolve: { adminResolverCompany: AdministratorCompanyHandlingResolver} },
  {
    path: "administrator/companyHandling",
    component: AdministratorCompanyHandlingComponent,
  },
  {
    path: "administrator/jobPostHandling",
    component: AdministratorJobPostHandlingComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
